/**
 * Wires Shopify New Customer Accounts shop-login-button attributes.
 * Mirrors Horizon/5star account-login-actions behaviour.
 */
class ZalAccountLoginActions extends HTMLElement {
  connectedCallback() {
    var shopLoginButton = this.querySelector('shop-login-button');
    if (!shopLoginButton) return;

    var returnUri = this.getAttribute('data-return-uri') || window.location.href;

    shopLoginButton.setAttribute('full-width', 'true');
    shopLoginButton.setAttribute('persist-after-sign-in', 'true');
    shopLoginButton.setAttribute('analytics-context', 'loginWithShopSelfServe');
    shopLoginButton.setAttribute('flow-version', 'account-actions-popover');
    shopLoginButton.setAttribute('return-uri', returnUri);

    shopLoginButton.addEventListener('completed', function () {
      window.location.reload();
    });
  }
}

if (!customElements.get('zal-account-login-actions')) {
  customElements.define('zal-account-login-actions', ZalAccountLoginActions);
}
